import React, { useEffect } from "react";
import RegistrationCheck from "./RegistrationCheck";
import useAuthenticationStore, { AuthenticationViews } from "./Store";
import { useNavigate } from "react-router-dom";

const RegistrationCheckContainer: React.FC = () => {
  const { state, getRegistrationStatus } = useAuthenticationStore()
  const { serverError, emailOrPhone } = state
  const navigate = useNavigate();

  useEffect(() => {
    if (!emailOrPhone) {
      navigate('../' + AuthenticationViews.login)
      return
    }
    getRegistrationStatus(emailOrPhone)
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <RegistrationCheck
    serverError={serverError}
  />;
}

export default RegistrationCheckContainer;
